// extracted by mini-css-extract-plugin
export default {"Container":"SimpleCenteredLayout__Container__1LpB1","ContentWrapper":"SimpleCenteredLayout__ContentWrapper__QCdaF"};